import React, { Component } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout/Layout"
import Seo from "../components/Core/Seo"
import styled from "styled-components"
import H1 from "../components/Core/Engagement/H1"
import breakpoints from "../styles/breakpoints"
import { withTranslation } from "gatsby-plugin-react-i18next"

const Container = styled.div`
  margin-bottom: 150px;
  padding-left: 45px;
  padding-right: 45px;  
`;

const Block = styled.div`
  text-align: center;
  max-width: 900px;
  margin: 100px auto 0 auto;
      
  @media(min-width: ${breakpoints.lg}) {
    margin-top: 200px;
  }
`;

class NotFoundPage extends Component {
  render() {
    const { t } = this.props;
    return (
      <Layout>
        <Seo title={t('not_found.title')}
             fullTitle={true}
             description={t('not_found.description')}/>
        <Container>
          <Block>
            <H1>{t('not_found.description')}</H1>
          </Block>
        </Container>
      </Layout>
    );
  }
}

export default withTranslation()(NotFoundPage);

export const pageQuery = graphql`
  query FourOFourQuery($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
